var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.extraItem.extras('banner.display'))?_c('div',{staticClass:"header-banner"},[_c('img',{staticClass:"header-banner-image",attrs:{"src":_vm.extraItem.extras('banner.src')}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }